import { Routes, Route, useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
import { useState } from "react";

import Home from "./pages/Home/Home";
import Projects from "./pages/Projects/Projects";
import About from "./pages/About/About";
import NotFound from "./pages/NotFound/NotFound";
import Overlay from "./components/UI/Overlay";

const App = () => {
  const [overlayState, setOverlayState] = useState("NONE");

  const navigator = useNavigate();

  const projectsButtonClickHandler = (event) => {
    setOverlayState("ENTER");
    setTimeout(() => {
      navigator("/projects", {
        replace: false,
      });
      setOverlayState("EXIT");
      setTimeout(() => {
        setOverlayState("NONE");
      }, 500);
    }, 500);
  };

  const aboutButtonClickHandler = (event) => {
    setOverlayState("ENTER");
    setTimeout(() => {
      navigator("/about", {
        replace: false,
      });
      setOverlayState("EXIT");
      setTimeout(() => {
        setOverlayState("NONE");
      }, 500);
    }, 500);
  };

  return (
    <>
      {createPortal(
        <Overlay overlayState={overlayState} />,
        document.getElementById("overlay")
      )}
      {/* <Overlay overlayState={"EXIT"} /> */}
      <Routes>
        <Route
          path="/"
          element={
            <Home
              onAboutClicked={aboutButtonClickHandler}
              onProjectsClicked={projectsButtonClickHandler}
            />
          }
        />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
